{
  "adhoc": {
    "archiveQuestion": "Archivar pregunta",
    "confirmArchiveMessage": "¿Estás seguro de que quieres archivar esta pregunta? Se moverá a los archivos.",
    "confirmDeletePermanentlyMessage": "¿Seguro que deseas eliminar permanentemente esta pregunta? Esta acción no se puede deshacer.",
    "confirmRestoreMessage": "¿Seguro que deseas restaurar esta pregunta? Volverá a ser visible.",
    "deleteQuestionPermanently": "Eliminar pregunta permanentemente",
    "noResultsYet": "Aún no hay resultados",
    "restoreQuestion": "Restaurar pregunta",
    "runSimulationToSeeResults": "Ejecuta la pregunta para ver los resultados aquí",
    "triggeringQuestion": "Iniciando..."
  },
  "audienceBuilder": {
    "addBehaviorGroup": "Agregar grupo de comportamientos",
    "addMarket": "Añadir segmento",
    "addingMarket": "Añadiendo segmento...",
    "ageRange": "Rango de edad",
    "allGenders": "Todos los géneros",
    "audienceSummary": "Resumen de audiencia",
    "behaviorGroup": "Grupo de comportamientos {{index}}",
    "behaviors": "Comportamientos",
    "completedSummary": {
      "one": "Tu estudio alcanzó {{respondents}} encuestados en {{count}} segmento.",
      "other": "Tu estudio alcanzó {{respondents}} encuestados en {{count}} segmentos.",
      "zero": "Tu estudio alcanzó {{respondents}} encuestados."
    },
    "continue": "Continuar",
    "countries": "Países",
    "countryCount": {
      "one": "{{count}} país",
      "other": "{{count}} países",
      "zero": "Mundo entero"
    },
    "demographics": "Filtrar demografía",
    "demographicsReadonly": "Demografía",
    "equalizeWeights": "Igualar",
    "extraFilters": {
      "one": "+{{count}} filtro",
      "other": "+{{count}} filtros",
      "zero": "Sin filtros"
    },
    "gender": "Género",
    "genderAgeSummary": "{{gender}}, {{ageMin}}-{{ageMax}}",
    "inProgressSummary": "Tu estudio está en curso. Los resultados estarán disponibles en breve.",
    "launchBlockedByErrors": {
      "one": "{{count}} error por corregir",
      "other": "{{count}} errores por corregir"
    },
    "launchEstimate": {
      "one": "Resultados en aproximadamente {{count}} minuto.",
      "other": "Resultados en aproximadamente {{count}} minutos.",
      "zero": "Resultados en menos de un minuto."
    },
    "launchStudy": "Lanzar estudio",
    "launchSummary": {
      "one": "Tu estudio alcanzará {{respondents}} encuestados en {{count}} segmento.",
      "other": "Tu estudio alcanzará {{respondents}} encuestados en {{count}} segmentos.",
      "zero": "Tu estudio alcanzará {{respondents}} encuestados."
    },
    "mapViewWorld": "Mundo",
    "mapWebOnly": "Mapa disponible solo en la web",
    "marketName": "Segmento {{number}}",
    "presetAfrica": "África",
    "presetAsia": "Asia",
    "presetEurope": "Europa",
    "presetMiddleEast": "Oriente Medio",
    "presetNorthAmerica": "América del Norte",
    "presetOceania": "Oceanía",
    "presetSouthAmerica": "América del Sur",
    "questionSubtitle": "Escribe tu pregunta y configura las opciones de respuesta a continuación.",
    "questionTitle": "¿Qué quieres preguntar?",
    "readyToLaunch": "Listo para lanzar",
    "respondentsShort": "{{count}} enc.",
    "resultsSubtitle": "Revisa los resultados de tu simulación de audiencia",
    "resultsTitle": "Resultados",
    "sampleSize": "Tamaño de muestra para este estudio",
    "savedMarket": "Segmento guardado",
    "savedMarkets": "Segmentos guardados",
    "searchCountries": "Buscar países",
    "searchStates": "Buscar estados",
    "seeProgress": "Ver progreso",
    "seeResults": "Ver resultados",
    "selectCountries": "Seleccionar países",
    "selectSegmentHint": "Seleccione un segmento para continuar",
    "selectedDemographics": {
      "one": "{{label}}: {{count}} filtro",
      "other": "{{label}}: {{count}} filtros",
      "zero": "Sin {{label}}"
    },
    "stepAudience": "Audiencia",
    "stepQuestion": "Pregunta",
    "stepResults": "Resultados",
    "studyComplete": "Estudio completado",
    "studyInProgress": "Estudio en curso",
    "studyQuestionsSubtitle": "Construye las preguntas y secciones de tu encuesta.",
    "studyQuestionsTitle": "Diseña tu encuesta",
    "subtitle": "Elige un segmento guardado, describe tu audiencia o personaliza los filtros a continuación.",
    "title": "¿A quién quieres llegar?"
  },
  "auth": {
    "subtitle": "Investigación de mercado continua para marcas que se mueven rápido.",
    "tagline": "Simula cada audiencia, ",
    "taglineItalic": "obtén insights en minutos"
  },
  "billing": {
    "activity": "Actividad",
    "columnAmount": "Monto",
    "columnCredits": "Créditos",
    "columnDate": "Fecha",
    "columnInvoice": "Factura",
    "columnStatus": "Estado",
    "columnType": "Tipo",
    "creditBalance": "Saldo de créditos",
    "currentPlan": "Plan actual",
    "estimatedCost": {
      "one": "Costo estimado: {{count}} crédito",
      "other": "Costo estimado: {{count}} créditos"
    },
    "intervalDay": "Diario",
    "intervalMonth": "Mensual",
    "intervalWeek": "Semanal",
    "intervalYear": "Anual",
    "invoices": "Facturas",
    "manage": "Gestionar",
    "next": "Siguiente",
    "noInvoices": "Sin facturas encontradas.",
    "noPlan": "Sin plan activo",
    "noTransactions": "Sin actividad encontrada.",
    "pageOf": "Página {{current}} de {{total}}",
    "previous": "Anterior",
    "quickInsights": "Preguntas rápidas",
    "statusPending": "Pendiente",
    "statusProcessed": "Procesado",
    "study": "Estudio",
    "subscribe": "Suscribirse",
    "subtitle": "Gestiona tus créditos, suscripción y facturas.",
    "title": "Facturación",
    "type": {
      "adjustment": "Ajuste",
      "hold": "Reserva de créditos",
      "refund": "Reembolso",
      "subscription": "Renovación de suscripción",
      "topup": "Compra de créditos",
      "usage": "Uso de simulación"
    },
    "unlimited": "Ilimitado"
  },
  "clerk": {
    "newDeviceNotice": "Está iniciando sesión desde un dispositivo nuevo. Por seguridad, le enviamos un código de verificación. Puede tardar hasta un minuto en llegar. Revise también su carpeta de spam.",
    "noAccount": "¿No tiene una cuenta?",
    "requestFreeTrial": "Solicitar prueba gratuita",
    "resendCode": "¿Aún no llega? Reenviar el código",
    "waitlistAlreadyAccess": "¿Ya tiene acceso?",
    "waitlistSignIn": "Iniciar sesión",
    "waitlistSubtitle": "Ingrese su dirección de correo electrónico para solicitar una prueba gratuita de 7 días",
    "waitlistSuccessMessage": "Será redirigido pronto...",
    "waitlistSuccessSubtitle": "Nos pondremos en contacto con usted en breve",
    "waitlistSuccessTitle": "¡Gracias por solicitar una prueba gratuita!",
    "waitlistTitle": "Prueba gratuita"
  },
  "dashboard": {
    "activeStudies": "Estudios",
    "activeStudiesCount": {
      "one": "{{count}} activo",
      "other": "{{count}} activos",
      "zero": "Ninguno activo"
    },
    "activeStudiesDescription": "Para investigaciones avanzadas y en profundidad que requieren más control",
    "allUseCases": "Todas las pruebas",
    "customTest": "Prueba personalizada",
    "errorLoadingStudies": "No se pudieron cargar los estudios",
    "getStarted": "Comenzar",
    "linearScaleDescription": "Escalas numéricas personalizadas",
    "managePanels": "Segmentos guardados",
    "managePanelsDescription": "Configura la demografía y ajustes de tus segmentos",
    "multiSelectMatrixDescription": "Varias selecciones por fila en cuadrícula",
    "multipleChoiceDescription": "Selecciona todas las opciones válidas",
    "noLaunchPermission": "No tienes los permisos necesarios para lanzar esta simulación.",
    "noRecentStudies": "No hay estudios recientes",
    "npsDescription": "Probabilidad de recomendación, en una escala de 0 a 10",
    "openEndedDescription": "Recoge respuestas de texto libre",
    "pastQuestions": "Preguntas anteriores",
    "pricingDescription": "Pide a los encuestados que indiquen el precio que pagarían por un producto o servicio.",
    "questionCount": {
      "one": "{{count}} pregunta",
      "other": "{{count}} preguntas",
      "zero": "Sin preguntas"
    },
    "quickActions": "Acciones rápidas",
    "quickInsights": "Tests rápidos",
    "quickInsightsDescription": "Lanza pruebas rápidas sobre anuncios, empaques, claims y más con nuestras plantillas listas para usar.",
    "quickTests": "Pruebas rápidas",
    "rankingDescription": "Ordena los elementos por cualquier criterio",
    "ratingScaleDescription": "Evalúa en una escala numérica",
    "recentStudies": "Estudios recientes",
    "seeMore": "Ver más",
    "singleChoiceDescription": "Elige una respuesta de una lista",
    "singleSelectMatrixDescription": "Una selección por fila en cuadrícula",
    "useCases": {
      "adCreative": "Test Creatividad",
      "adCreativeDescription": "Muestra tus anuncios a cada consumidor, uno a la vez, midiendo qué retienen, cuánto les gustan y el interés que despiertan.",
      "awareness": "Notoriedad de Marca",
      "awarenessDescription": "Mide cuántos consumidores piensan en cada marca de tu categoría por sí solos, y cuántos la reconocen en una lista.",
      "claimTest": "Test de Claims",
      "claimTestDescription": "Muestra tus claims a cada consumidor, uno a la vez, midiendo qué entienden, qué tan creíbles les parecen y qué tanto los motivan.",
      "maxDiff": "MaxDiff",
      "maxDiffDescription": "Muestra a los consumidores pequeños grupos de elementos y pídeles elegir el mejor y el peor, en varias rondas, para ver lo que importa.",
      "monadic": "Prueba de conceptos",
      "monadicDescription": "Muestra a cada consumidor un solo concepto a la vez, para que cada idea se evalúe por sí sola y no junto a otras.",
      "nps": "NPS",
      "npsDescription": "Pregunta a los consumidores qué tan probable es que recomienden tu producto en una escala de 0 a 10, y la razón de su nota.",
      "packaging": "Prueba de empaque",
      "packagingDescription": "Muestra tus empaques a cada consumidor, uno a la vez, midiendo qué producto ven, qué tan atractivos les parecen y su visibilidad en anaquel.",
      "preferenceTest": "Prueba de preferencia",
      "preferenceTestDescription": "Muestra a los consumidores dos opciones o más en paralelo (anuncios, empaques o claims) y descubre cuál prefieren, y por qué.",
      "priceElasticity": "Elasticidad de Precio",
      "priceElasticityDescription": "Identifica el rango de precio donde los consumidores ven valor real, qué parece demasiado barato, demasiado caro, o justo.",
      "turf": "TURF",
      "turfDescription": "Encuentra el surtido más pequeño, para un anaquel, un menú o una gama, que satisface al mayor abanico de gustos."
    },
    "viewAll": "Ver todo",
    "welcome": "¡Bienvenido, {{name}}!",
    "welcomeDescription": "¿Qué te gustaría probar hoy?",
    "yourFavorites": "Tus favoritos"
  },
  "dashboardNavigator": {
    "accountLanguageDefault": "Idioma de la cuenta (Por defecto)",
    "accountProfile": "Perfil",
    "accountSecurity": "Seguridad",
    "accountSecurityDescription": "Gestiona tu contraseña, dispositivos y sesiones activas.",
    "accountSettings": "Configuración de cuenta",
    "activeSessions": "Sesiones activas",
    "addEmailPlaceholder": "Añadir nueva dirección de correo",
    "age": "{{age}} años",
    "ageRange": "La edad debe estar entre {{lowerBound}} y {{upperBound}}",
    "allGroups": "Todos los grupos",
    "archives": "Archivos",
    "areaType": "Tipo de área",
    "avgRank": "Rango prom.",
    "behaviorLabel": "Comportamiento",
    "behaviorPlaceholder": "Prefiere compras online",
    "behaviors": {
      "one": "1 comportamiento",
      "other": "{{count}} comportamientos",
      "zero": "Sin comportamientos"
    },
    "browserDefault": "Navegador (Por defecto)",
    "cannotUnlinkLastAccount": "Necesitas al menos un método de inicio de sesión. Establece una contraseña primero para desvincular esta cuenta.",
    "changePassword": "Cambiar contraseña",
    "chartTitleDistribution": {
      "one": "Distribución (1 respuesta)",
      "other": "Distribución ({{count}} respuestas)",
      "zero": "Distribución (Sin encuestados)"
    },
    "chartTitleHeatmap": {
      "one": "Mapa temático (1 respuesta)",
      "other": "Mapa temático ({{count}} respuestas)",
      "zero": "Mapa temático (Sin encuestados)"
    },
    "chartTitleKeyThemes": {
      "one": "Temas clave (1 respuesta)",
      "other": "Temas clave ({{count}} respuestas)",
      "zero": "Temas clave (Sin encuestados)"
    },
    "chartTitleNps": {
      "one": "Net Promoter Score (1 encuestado)",
      "other": "Net Promoter Score ({{count}} encuestados)",
      "zero": "Net Promoter Score (Sin encuestados)"
    },
    "chartTitleNpsBreakdown": {
      "one": "Desglose de NPS (1 encuestado)",
      "other": "Desglose de NPS ({{count}} encuestados)",
      "zero": "Desglose de NPS (Sin encuestados)"
    },
    "chartTitlePriceDistribution": {
      "one": "Distribución de precios (1 encuestado)",
      "other": "Distribución de precios ({{count}} encuestados)",
      "zero": "Distribución de precios (Sin encuestados)"
    },
    "chartTitleRatings": {
      "one": "Valoración media (1 encuestado)",
      "other": "Valoración media ({{count}} encuestados)",
      "zero": "Valoración media (Sin encuestados)"
    },
    "chartTitleRatingsBreakdown": {
      "one": "Desglose de valoraciones (1 encuestado)",
      "other": "Desglose de valoraciones ({{count}} encuestados)",
      "zero": "Desglose de valoraciones (Sin encuestados)"
    },
    "chartTitleResponseDistribution": {
      "one": "Distribución de elecciones (1 encuestado)",
      "other": "Distribución de elecciones ({{count}} encuestados)",
      "zero": "Distribución de elecciones (Sin encuestados)"
    },
    "chartTitleResponseMatrix": {
      "one": "Respuestas por categoría (1 encuestado)",
      "other": "Respuestas por categoría ({{count}} encuestados)",
      "zero": "Respuestas por categoría (Sin encuestados)"
    },
    "chartTitleResponseRanking": {
      "one": "Desglose del ranking (1 encuestado)",
      "other": "Desglose del ranking ({{count}} encuestados)",
      "zero": "Desglose del ranking (Sin encuestados)"
    },
    "chartTitleScoreDistribution": {
      "one": "Desglose de puntuaciones (1 encuestado)",
      "other": "Desglose de puntuaciones ({{count}} encuestados)",
      "zero": "Desglose de puntuaciones (Sin encuestados)"
    },
    "chartTitleTopResponses": {
      "one": "Principales respuestas (1 respuesta)",
      "other": "Principales respuestas ({{count}} respuestas)",
      "zero": "Principales respuestas (Sin encuestados)"
    },
    "chartTooltipHeatmap": "{{line}}: {{option}}",
    "children": {
      "one": "1 hijo",
      "other": "{{count}} hijos",
      "zero": "Sin hijos"
    },
    "comingSoon": "Próximamente",
    "comingSoonDescription": "Estamos trabajando en la integración con estas plataformas para ayudarte a ejecutar simulaciones con tus propios datos. ¡Mantente atento!",
    "confirmDeleteGroup": "Eliminar grupo",
    "confirmDeleteGroupMessage": "¿Estás seguro de que quieres eliminar este grupo? Esta acción no se puede deshacer.",
    "confirmPassword": "Confirmar contraseña",
    "connectedAccounts": "Cuentas conectadas",
    "conversation": "Conversación",
    "count": "Recuento",
    "current": "Actual",
    "currentPassword": "Contraseña actual",
    "dataSources": "Fuentes de datos",
    "dataSourcesExplanation": "Conecta tus fuentes de datos para ejecutar simulaciones con tus propias personas.",
    "deleteEmail": "Eliminar correo",
    "deleteEmailConfirm": "¿Estás seguro de que quieres eliminar {{email}}?",
    "demographics": "Demografía",
    "devices": {
      "one": "1 dispositivo",
      "other": "{{count}} dispositivos",
      "zero": "Sin dispositivos"
    },
    "educationLabel": "Educación",
    "emailAddresses": "Direcciones de correo",
    "employmentStatus": "Empleo",
    "enterFirstName": "Introduce tu nombre",
    "enterLastName": "Introduce tu apellido",
    "errorLoadingConversation": "Error al cargar la conversación",
    "errorLoadingDemographics": "Error al cargar los datos demográficos",
    "ethnicity": "Etnia",
    "firstName": "Nombre",
    "home": "Inicio",
    "householdLabel": "Tamaño del hogar",
    "income": "Ingresos",
    "keyInsights": "Información clave",
    "languageSettings": "Configuración de idioma",
    "lastName": "Apellido",
    "linearScaleQuestionTitle": "Escala lineal",
    "location": "Ubicación",
    "locationUnknown": "Ubicación desconocida",
    "logout": "Cerrar sesión",
    "logoutConfirm": "¿Estás seguro de que quieres cerrar sesión?",
    "maritalStatus": "Estado civil",
    "maxSmallerThanMin": "El máximo debe ser mayor que el mínimo",
    "multiSelectMatrixQuestionTitle": "Matriz de selección múltiple",
    "multipleChoiceQuestionTitle": "Opción múltiple",
    "newPassword": "Nueva contraseña",
    "noActiveSessions": "No hay sesiones activas",
    "noConnectedAccounts": "No hay cuentas conectadas",
    "noData": "No hay datos disponibles",
    "noPasswordSet": "Sin contraseña establecida",
    "npsDetractors": "Detractores",
    "npsPassives": "Pasivos",
    "npsPromoters": "Promotores",
    "npsQuestionTitle": "NPS",
    "npsScale": "−100 a 100",
    "occupation": "Ocupación",
    "openEndedQuestionTitle": "Respuesta abierta",
    "organization": "Organización",
    "organizationAdmin": "Admin",
    "organizationDescription": "Consulta los miembros, gestiona roles y los detalles de la organización.",
    "organizationDomains": "Dominios verificados",
    "organizationFullName": "Nombre completo",
    "organizationMember": "Miembro",
    "organizationMembers": "Miembros",
    "organizationNoDomains": "Sin dominios verificados",
    "organizationNoMembers": "No se encontraron miembros",
    "organizationOwner": "Propietario",
    "organizationRole": "Rol",
    "organizationYou": "Tú",
    "panels": "Segmentos",
    "password": "Contraseña",
    "passwordEnabled": "Contraseña habilitada",
    "passwordProtected": "Tu cuenta está protegida con contraseña",
    "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
    "passwordUpdateFailed": "Error al actualizar la contraseña. Verifica tu contraseña actual.",
    "passwordsDoNotMatch": "Las contraseñas no coinciden",
    "personalInformation": "Información personal",
    "personality": "Personalidad",
    "pricingQuestionTitle": "Pregunta de precio",
    "primary": "Principal",
    "questions": "Preguntas",
    "rankingQuestionTitle": "Clasificación",
    "ratingScaleQuestionTitle": "Valoración",
    "regionTypeRural": "Rural",
    "regionTypeSuburban": "Suburbano",
    "regionTypeUrban": "Urbano",
    "respondents": {
      "one": "1 encuestado",
      "other": "{{count}} encuestados",
      "zero": "Ningún encuestado"
    },
    "results": "Resultados",
    "revoke": "Revocar",
    "revokeSession": "Revocar sesión",
    "revokeSessionConfirm": "Esto cerrará la sesión en este dispositivo. El usuario deberá iniciar sesión de nuevo.",
    "revoking": "Revocando...",
    "seeAllCount": {
      "one": "Ver todo (1 verbatim)",
      "other": "Ver todo ({{count}} verbatims)",
      "zero": "Ver todo"
    },
    "setPassword": "Establecer contraseña",
    "setPasswordPrompt": "Añade una contraseña para proteger tu cuenta",
    "settings": "Configuración",
    "settingsDescription": "Gestiona tus preferencias de idioma y la configuración de seguridad.",
    "signOut": "Cerrar sesión",
    "signOutDescription": "Cerrar sesión en este dispositivo.",
    "singleChoiceQuestionTitle": "Opción única",
    "singleSelectMatrixQuestionTitle": "Matriz de selección única",
    "studies": "Estudios",
    "studyLanguage": "Idioma de los estudios",
    "studyLanguageDescription": "Establece el idioma predeterminado para tus estudios y encuestas.",
    "traits": "Rasgos",
    "unknownDevice": "Dispositivo desconocido",
    "unlink": "Desvincular",
    "unlinkAccount": "Desvincular cuenta",
    "unlinkAccountConfirm": "¿Estás seguro de que quieres desvincular tu cuenta de {{provider}}? Ya no podrás iniciar sesión con esta cuenta.",
    "unlinking": "Desvinculando...",
    "values": "Valores",
    "verificationCode": "Código de verificación",
    "verifyEmail": "Introduce el código de verificación enviado a {{email}}",
    "websiteLanguage": "Idioma del sitio web",
    "websiteLanguageDescription": "Establece el idioma de visualización de la interfaz del sitio web.",
    "weight": "Peso",
    "whatConsumersSaid": "Lo que dijeron los consumidores"
  },
  "dataSources": {
    "aws": "AWS",
    "awsDescription": "Amazon Web Services",
    "codence": "Codence",
    "codenceDescription": "Plataforma de investigación de clientes",
    "dovetail": "Dovetail",
    "dovetailDescription": "Hub de información de clientes con IA",
    "enjoyHQ": "EnjoyHQ",
    "enjoyHQDescription": "Repositorio de investigación de usuarios",
    "googleAds": "Google Ads",
    "googleAdsDescription": "Plataforma de publicidad de Google",
    "googleCloud": "Google Cloud",
    "googleCloudDescription": "Plataforma de Google Cloud",
    "hubspot": "Hubspot",
    "hubspotDescription": "Plataforma de marketing y ventas",
    "maze": "Maze",
    "mazeDescription": "Plataforma de descubrimiento de productos",
    "metaAds": "Meta Ads",
    "metaAdsDescription": "Anuncios de Facebook e Instagram",
    "microsoftAzure": "Microsoft Azure",
    "microsoftAzureDescription": "Plataforma de Microsoft Cloud",
    "oracleCloud": "Oracle Cloud",
    "oracleCloudDescription": "Infraestructura de Oracle Cloud",
    "salesforce": "Salesforce",
    "salesforceDescription": "Gestión de relaciones con clientes",
    "tiktokAds": "TikTok Ads",
    "tiktokAdsDescription": "Plataforma de publicidad de TikTok"
  },
  "demographics": {
    "female": "Mujer",
    "male": "Hombre",
    "nonBinary": "No binario"
  },
  "folders": {
    "confirmArchive": "Archivar carpeta",
    "confirmArchiveMessage": "¿Estás seguro de que quieres archivar \"{{name}}\"? Todo el contenido dentro también será archivado.",
    "confirmDeletePermanentlyMessage": "¿Estás seguro de que quieres eliminar permanentemente esta carpeta y todo su contenido? Esta acción no se puede deshacer.",
    "confirmRestoreMessage": "¿Estás seguro de que quieres restaurar esta carpeta? Todo el contenido dentro también será restaurado.",
    "currentLocation": "Ubicación actual",
    "deleteFolderPermanently": "Eliminar carpeta permanentemente",
    "errorLoadingFolders": "Error al cargar las carpetas",
    "folderNamePlaceholder": "Nombre de la carpeta...",
    "moveItem": "Mover {{name}}",
    "newFolder": "Nueva carpeta",
    "noFoldersYet": "Sin carpetas",
    "rename": "Renombrar carpeta",
    "renameFolder": "Renombrar",
    "subFolderCount": {
      "one": "{{count}} subcarpeta",
      "other": "{{count}} subcarpetas"
    }
  },
  "menu": {
    "account": "Cuenta",
    "accountDescription": "Gestiona tu perfil, correos electrónicos y cuentas conectadas.",
    "archives": "Archivos",
    "billing": "Facturación",
    "logout": "Cerrar sesión",
    "logoutConfirm": "¿Seguro que quieres cerrar sesión en tu cuenta?",
    "managePlan": "Gestionar plan",
    "openMenu": "Abrir menú",
    "organization": "Organización",
    "settings": "Configuración",
    "subscribe": "Suscribirse"
  },
  "misc": {
    "apply": "Aplicar",
    "archive": "Archivar",
    "archived": "Archivado",
    "archivedQuestionBanner": "Estás viendo una pregunta archivada. Restáurala para hacer cambios.",
    "archivedStudyBanner": "Estás viendo un estudio archivado. Restáuralo para hacer cambios.",
    "archivesEmptyDescription": "Los elementos archivados aparecerán aquí.",
    "archiving": "Archivando...",
    "back": "Volver",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "completed": "Completado",
    "create": "Crear",
    "creating": "Creando...",
    "creatingStudy": "Creando estudio...",
    "delete": "Eliminar",
    "deletePermanently": "Eliminar permanentemente",
    "deleting": "Eliminando...",
    "draft": "Borrador",
    "dropFilesHere": "Suelta los archivos aquí",
    "duplicate": "Duplicar",
    "duplicating": "Duplicando...",
    "edit": "Editar",
    "errorLoadingQuestion": "Error al cargar la pregunta",
    "errorLoadingQuestions": "Error al cargar las preguntas",
    "errorOccurred": "Ha ocurrido un error.",
    "failed": "Fallido",
    "failedToGenerateSummary": "Error al generar el resumen.",
    "fileSizeExceededImage": "La imagen excede el tamaño máximo de {{maxSize}}MB",
    "fileSizeExceededVideo": "El vídeo excede el tamaño máximo de {{maxSize}}MB",
    "filesRejected": "{{count}} archivos rechazados: {{reason}}",
    "generatingSummary": "Generando resumen…",
    "hoursShort": "{{count}}h",
    "imageUpToSize": "Imágenes de hasta {{maxSize}}MB cada una",
    "in_progress": "En progreso",
    "invalidImageFormat": "Formato de imagen inválido. Por favor, sube imágenes JPEG, PNG, GIF o WebP.",
    "invalidMediaFormat": "Formato de archivo inválido. Por favor, sube imágenes o vídeos válidos.",
    "invalidVideoFormat": "Formato de vídeo inválido. Por favor, sube vídeos MP4 o WebM.",
    "loading": "Cargando...",
    "maxItemsReached": "Máximo de {{max}} elementos permitidos",
    "mediaUpToSize": "Imágenes de hasta {{imageMaxSize}}MB cada una, vídeos de hasta {{videoMaxSize}}MB cada uno",
    "minutesShort": "{{count}}m",
    "move": "Mover",
    "moving": "Moviendo...",
    "noArchivedQuestions": "No hay preguntas archivadas",
    "noArchivedQuestionsDescription": "Las preguntas archivadas aparecerán aquí.",
    "noArchivedSegments": "No hay segmentos archivados",
    "noArchivedSegmentsDescription": "Los segmentos archivados aparecerán aquí.",
    "noArchivedStudies": "No hay estudios archivados",
    "noArchivedStudiesDescription": "Los estudios archivados aparecerán aquí.",
    "noQuestionsYet": "Aún no hay preguntas",
    "noSearchResults": "No se encontraron resultados",
    "noSearchResultsDescription": "Intenta ajustar tus términos de búsqueda",
    "otherValues": "Otros",
    "permissionRequiredMessage": "Lo sentimos, necesitamos permisos de galería para seleccionar archivos.",
    "readMore": "Leer más",
    "ready": "Listo",
    "reset": "Restablecer",
    "restore": "Restaurar",
    "restoring": "Restaurando...",
    "retrying": "Reintentando...",
    "save": "Guardar",
    "saving": "Guardando...",
    "search": "Buscar...",
    "searchQuestions": "Buscar preguntas...",
    "searchStudies": "Buscar estudios...",
    "secondsShort": "{{count}}s",
    "seeLess": "Ver menos",
    "seeMore": "Ver más",
    "selectedImageAlt": "Imagen seleccionada {{index}}",
    "showOriginal": "Ver original",
    "showTranslation": "Ver traducción",
    "tapToSelectImages": "Toca para seleccionar imágenes",
    "tapToSelectMedia": "Toca para seleccionar archivos",
    "tapToSelectVideos": "Toca para seleccionar vídeos",
    "translatedFrom": "Traducido desde {{language}}",
    "tryAgain": "Intentar de nuevo",
    "typeMessage": "Escribe un mensaje...",
    "unknown": "Desconocido",
    "uploadImages": "Subir imágenes (hasta {{max}})",
    "uploadMedia": "Subir archivos (hasta {{max}})",
    "uploadVideos": "Subir vídeos (hasta {{max}})",
    "uploadingMedia": {
      "one": "Subiendo 1 archivo... {{percent}}",
      "other": "Subiendo {{count}} archivos... {{percent}}",
      "zero": "No hay archivos para subir"
    },
    "videoUpToSize": "Vídeos de hasta {{maxSize}}MB cada uno"
  },
  "notFound": {
    "goToHomeScreen": "Ir a la pantalla de inicio",
    "notFound": "No se puede encontrar lo que buscas"
  },
  "panels": {
    "confirmArchive": "Archivar segmento",
    "confirmArchiveMessage": "¿Estás seguro de que quieres archivar este segmento?\nLos grupos que usan este segmento seguirán funcionando, pero no podrás usar este segmento para grupos nuevos.",
    "createPanel": "Crear segmento",
    "default": "Predeterminado",
    "demographics": "Demografía",
    "description": "Descripción",
    "editPanel": "Editar segmento",
    "errorLoadingPanels": "Error al cargar los segmentos",
    "noSegments": "No hay segmentos",
    "noSegmentsDescription": "Aún no hay segmentos disponibles.",
    "panelName": "Nombre del segmento",
    "setAsDefault": "Establecer como predeterminado"
  },
  "questions": {
    "addConditionalRule": "Añadir regla condicional",
    "addOption": "Añadir opción",
    "addProbabilityRule": "Añadir regla de probabilidad",
    "advancedSettings": "Ajustes avanzados",
    "afterThisQuestion": "Después de esta pregunta:",
    "archiveQuestion": "Archivar pregunta",
    "arrow": "→",
    "averagePrice": {
      "one": "Precio promedio (1 encuestado)",
      "other": "Precio promedio ({{count}} encuestados)",
      "zero": "Precio promedio (Sin encuestados)"
    },
    "averageScore": {
      "one": "Puntuación promedio (1 encuestado)",
      "other": "Puntuación promedio ({{count}} encuestados)",
      "zero": "Puntuación promedio (Sin encuestados)"
    },
    "carryForward": {
      "exclude": "excluyendo los elementos seleccionados en Q{{number}}",
      "excludeHint": "Las opciones seleccionadas en esa pregunta se eliminan de la lista trasladada.",
      "excludeLabel": "Excluir opciones seleccionadas en (opcional)",
      "minRating": "Mostrar solo los elementos valorados \"{{label}}\" o más en Q{{number}}",
      "modeManualOptions": "Introducir opciones",
      "modeManualRows": "Introducir filas",
      "modeReuse": "Reutilizar una respuesta anterior",
      "none": "Ninguna",
      "portRatedPrefix": "Traslada las filas valoradas en",
      "portRatedSuffix": "o más como {{target}} de esta pregunta.",
      "portSelected": "Traslada las opciones seleccionadas como {{target}} de esta pregunta.",
      "reuseFrom": "Reutilizar respuestas de",
      "selected": "Mostrar solo los elementos seleccionados en Q{{number}}",
      "targetOptions": "opciones",
      "targetRows": "filas"
    },
    "categoryAssignment": {
      "addCondition": "Añadir condición",
      "addTrack": "Añadir ruta",
      "eligibilityContains": "Elegibilidad: Q{{number}} contiene \"{{option}}\"",
      "eligibilityDoesNotContain": "Elegibilidad: Q{{number}} no contiene \"{{option}}\"",
      "eligibilityHint": "Por defecto, cualquiera puede colocarse en cualquier ruta. Añade una condición para restringir una ruta a quienes dieron una respuesta concreta.",
      "eligibilityIs": "Elegibilidad: Q{{number}} es \"{{option}}\"",
      "eligibilityIsNot": "Elegibilidad: Q{{number}} no es \"{{option}}\"",
      "eligibleWhen": "Elegible si",
      "explanation": "Los encuestados se reparten en rutas. Usa la elegibilidad para controlar quién puede entrar en una ruta y la lógica de salto para dirigir cada ruta a preguntas distintas.",
      "leastFill": "Equilibrado",
      "leastFillHint": "Rellena las rutas de forma equilibrada, asignando siempre a la ruta elegible menos llena.",
      "method": "Método: {{method}}",
      "random": "Aleatorio",
      "randomHint": "Asigna a una ruta elegible al azar.",
      "setDestination": "Definir destino",
      "title": "Asignación de rutas",
      "trackLabel": "Ruta {{number}}",
      "trackStart": "La ruta comienza en",
      "tracksLabel": "Rutas"
    },
    "conditionalRuleDisplay": "Si \"{{sourceQuestion}}\" {{operator}} \"{{option}}\" → {{target}}",
    "conditionalRulesTakePrecedence": "Las reglas condicionales tienen prioridad sobre las reglas de probabilidad y la regla predeterminada",
    "confirmArchiveMessage": "¿Estás seguro de que quieres archivar esta pregunta? Se moverá a los archivos.",
    "confirmDelete": "Eliminar pregunta",
    "confirmDeleteMessage": "¿Estás seguro de que quieres eliminar esta pregunta? Esta acción no se puede deshacer.",
    "confirmDeletePermanentlyMessage": "¿Seguro que deseas eliminar permanentemente esta pregunta? Esta acción no se puede deshacer.",
    "confirmDeleteWithRulesMessage": "Esta pregunta es objetivo de {{count}} regla(s) de salto de otras preguntas. Eliminarla también eliminará esas reglas. Esta acción no se puede deshacer.",
    "confirmRestoreMessage": "¿Seguro que deseas restaurar esta pregunta? Volverá a ser visible.",
    "contains": "contiene",
    "continueToNext": "Continuar a la siguiente pregunta",
    "createQuestion": "Crear pregunta",
    "default": "Predeterminado",
    "deleteQuestionPermanently": "Eliminar pregunta permanentemente",
    "doesNotContain": "no contiene",
    "editorComingSoon": "Editor próximamente",
    "endSurvey": "Finalizar encuesta",
    "endSurveyWithProbability": "{{percentage}} → Finalizar encuesta",
    "enterOption": "Introducir opción...",
    "ifAnswer": "Si",
    "ifNotSelected": "si no se selecciona",
    "ifSelected": "si se selecciona",
    "is": "es",
    "isNot": "no es",
    "labelsTitle": "Etiquetas",
    "linearScale": {
      "label": "Etiqueta"
    },
    "longFormTextAnswer": "Respuesta de texto libre...",
    "matrix": {
      "addColumn": "Añadir columna",
      "addRow": "Añadir fila",
      "columnPlaceholder": "Etiqueta de columna...",
      "columns": "Columnas",
      "optionsRange": "{{from}} - {{to}} de {{total}} opciones",
      "rowPlaceholder": "Etiqueta de fila...",
      "rows": "Filas",
      "rowsRange": "{{from}} - {{to}} de {{total}} filas"
    },
    "minMediaHint": {
      "one": "Añade al menos {{count}} imagen",
      "other": "Añade al menos {{count}} imágenes"
    },
    "minOptionsHint": {
      "one": "Añade al menos {{count}} opción",
      "other": "Añade al menos {{count}} opciones"
    },
    "noLinesProvided": "Añadir filas",
    "noOptionsProvided": "Añadir opciones",
    "noTrackDestinations": "Asigna un destino a cada ruta",
    "npsExtremelyLikely": "Muy probable",
    "npsExtremelyUnlikely": "Muy poco probable",
    "option": "Opción {{number}}",
    "optionsLabel": "Opciones",
    "outOfStars": "de {{count}} estrellas",
    "pricingPlaceholder": "Escribe un precio…",
    "probabilityRulesSeparator": " • ",
    "probabilitySumError": "⚠️ La suma de probabilidades debe ser menor o igual que 100% (actualmente {{sum}})",
    "questionPlaceholder": "¿Qué te gustaría preguntar?",
    "ranking": {
      "addItem": "Añadir elemento",
      "itemPlaceholder": "Elemento a clasificar...",
      "itemsLabel": "Elementos a clasificar"
    },
    "removeRule": "Eliminar regla",
    "restoreQuestion": "Restaurar pregunta",
    "rulePrecedence": "Reglas de opción > Reglas condicionales > Reglas de probabilidad > Regla predeterminada",
    "scaleLabel": "Escala",
    "selectOption": "Seleccionar una opción",
    "selectScale": "Seleccionar escala",
    "skipLogic": "Lógica de salto",
    "skipToLabel": "Saltar a:",
    "skipToQuestion": "Saltar a {{number}}",
    "skipToQuestionWithProbability": "{{percentage}} Saltar a {{number}}",
    "stars": {
      "one": "{{count}} estrella",
      "other": "{{count}} estrellas",
      "zero": "{{count}} estrellas"
    },
    "types": {
      "categoryAssignment": "Asignación de rutas",
      "linearScale": "Escala lineal",
      "multiSelectMatrix": "Matriz de selección múltiple",
      "multipleChoice": "Opción múltiple",
      "nps": "NPS",
      "openEnded": "Respuesta abierta",
      "pricing": "Precio",
      "ranking": "Ranking",
      "ratingScale": "Valoración",
      "singleChoice": "Opción única",
      "singleSelectMatrix": "Matriz de selección única"
    },
    "untitled": "Pregunta sin título",
    "useImagesAsOptions": "Usar imágenes como opciones",
    "whenAnswer": "Cuando la respuesta",
    "yourQuestion": "Tu pregunta"
  },
  "runs": {
    "applyFilters": {
      "one": "Aplicar ({{count}} encuestado)",
      "other": "Aplicar ({{count}} encuestados)",
      "zero": "Aplicar (sin encuestados)"
    },
    "fetchingRespondents": "Obteniendo encuestados...",
    "filters": "Filtros"
  },
  "sharing": {
    "addPeople": "Agregar por nombre o email...",
    "directAccess": "Personas con acceso",
    "editPermission": "Editar",
    "errorLoading": "Error al cargar los permisos",
    "external": "Externo",
    "generalAccess": "Acceso general",
    "inheritedFrom": "Heredado de «{{name}}»",
    "manageAccess": "Compartir «{{name}}»",
    "owner": "Propietario",
    "restricted": "Restringido",
    "share": "Compartir",
    "viewPermission": "Ver",
    "you": "(tú)"
  },
  "studies": {
    "addSection": "Añadir sección",
    "allStudies": "Todos los estudios",
    "answersProgress": {
      "one": "{{completed}}/{{count}} respuesta recopilada",
      "other": "{{completed}}/{{count}} respuestas recopiladas"
    },
    "archiveStudy": "Archivar estudio",
    "cell": "Celda {{number}}",
    "cells": {
      "addCell": "Añadir celda",
      "addField": "Añadir variable",
      "cellNumber": "Celda {{number}}",
      "cells": "Celdas",
      "fieldNamePlaceholder": "Nombre de la variable",
      "noVariables": "Define primero las variables para añadir celdas.",
      "removeCell": "Eliminar celda",
      "removeField": "Eliminar campo",
      "required": "Obligatorio",
      "type": "Tipo",
      "typeImage": "Imagen",
      "typeText": "Texto",
      "variables": "Variables",
      "variablesHint": "Usa una variable en tus preguntas así:"
    },
    "confirmArchiveMessage": "¿Estás seguro de que quieres archivar este estudio? Se moverá a los archivos.",
    "confirmDeletePermanentlyMessage": "¿Seguro que deseas eliminar permanentemente este estudio? Se eliminarán todos los datos. Esta acción no se puede deshacer.",
    "confirmDeleteSection": "Eliminar sección",
    "confirmDeleteSectionMessage": "¿Estás seguro de que quieres eliminar esta sección? Todas las preguntas de esta sección serán movidas. Esta acción no se puede deshacer.",
    "confirmRestoreMessage": "¿Seguro que deseas restaurar este estudio? Volverá a ser visible.",
    "copyOf": "Copia de {{name}}",
    "coverPicture": "Imagen de portada",
    "createFirstStudy": "Crea tu primer estudio",
    "createFirstStudyDescription": "Completa los detalles para crear tu primer estudio de investigación",
    "createNewStudy": "Crear un nuevo estudio",
    "createNewStudyDescription": "Completa los detalles para crear un nuevo estudio de investigación",
    "createStudy": "Crear estudio",
    "deleteStudyPermanently": "Eliminar estudio permanentemente",
    "design": {
      "createStudy": "Crear estudio",
      "designStudy": "Diseñar estudio",
      "designing": "Diseñando...",
      "leave": "Salir",
      "leaveBody": "Tienes un borrador de estudio en revisión. Si sales de esta página se eliminará.",
      "leaveTitle": "¿Salir y eliminar el borrador?",
      "noPanelsFound": "No se encontraron segmentos",
      "placeholder": "p. ej. Probar tres claims de nuestra nueva bebida de avena con @Snackers Gen Z y comparar la intención de compra...",
      "regenerate": "Regenerar",
      "subtitle": "Describe lo que quieres aprender y etiqueta los segmentos a consultar. Escribe @ para mencionar un segmento.",
      "title": "¿Qué quieres descubrir?"
    },
    "duplicateStudy": "Duplicar estudio",
    "duplicateStudyDescription": "Crear una copia de este estudio con todas sus preguntas y grupos",
    "elementsProgress": {
      "one": "{{completed}}/{{count}} elemento procesado",
      "other": "{{completed}}/{{count}} elementos procesados"
    },
    "errorGettingResults": "Error al obtener los resultados",
    "errorGettingSimulationProgress": "Error al obtener el progreso de la simulación",
    "errorLoadingChat": "Error al cargar el chat",
    "errorLoadingStudies": "Error al cargar los estudios",
    "errorLoadingStudy": "Error al cargar el estudio",
    "errorRunningSimulation": "Error al ejecutar la simulación",
    "exportExcel": "Exportar como Excel",
    "exportPDF": "Exportar como PDF",
    "exportWord": "Exportar como Docx",
    "exporting": "Exportando...",
    "filterByType": "Filtrar por tipo",
    "group": "Grupo {{index}}",
    "keyTakeaways": "Puntos clave",
    "noChatMessages": "Aún no hay mensajes",
    "noDescription": "Sin descripción proporcionada",
    "noResultsYet": "Aún no hay resultados",
    "noResultsYetDescription": "Lanza una simulación para ver los resultados aquí.",
    "preparingContent": "Preparando contenido...",
    "qualitative": "Estudios cualitativos",
    "qualitativeDescription": "Información rica con explicaciones detalladas y resúmenes",
    "qualitativeShort": "Cualitativa",
    "quantitative": "Estudios cuantitativos",
    "quantitativeDescription": "Resultados rápidos enfocados en datos numéricos",
    "quantitativeShort": "Cuantitativa",
    "quickInsightsNudge": "¿Solo una pregunta? Prueba",
    "redirectingToResults": "Redirigiendo a sus resultados…",
    "respondentsProgress": {
      "one": "{{completed}}/{{count}} encuestado",
      "other": "{{completed}}/{{count}} encuestados"
    },
    "restoreStudy": "Restaurar estudio",
    "runInQueue": "Tu estudio está en cola y comenzará pronto",
    "runWaitingToStart": "Esperando para iniciar",
    "sectionEditor": {
      "addStimulus": "Añadir elemento",
      "cellsPerRespondent": "Celdas por encuestado",
      "cellsPerRespondentHint": {
        "one": "Cada encuestado ve 1 celda.",
        "other": "Cada encuestado ve {{count}} celdas."
      },
      "description": "Contexto para los encuestados",
      "descriptionPlaceholder": "Describe el producto, la marca o el escenario al que reaccionarán los encuestados.",
      "itemsPerCell": "Elementos por pantalla",
      "itemsPerCellHint": {
        "one": "Se muestra 1 estímulo por pantalla.",
        "other": "Se muestran {{count}} estímulos juntos en cada pantalla."
      },
      "products": {
        "addStimulus": "Añadir producto",
        "stimuli": "Productos",
        "stimulusPlaceholder": "Producto {{index}}",
        "summaryNoStimuli": "Añadir productos",
        "summaryStimuli": {
          "one": "1 producto",
          "other": "{{count}} productos"
        }
      },
      "requiresMediaHint": "Se requiere una imagen para cada elemento.",
      "settings": "Configuración",
      "stimuli": "Elementos",
      "stimulusPlaceholder": "Elemento {{index}}",
      "summaryCells": {
        "one": "1 celda por encuestado",
        "other": "{{count}} celdas por encuestado"
      },
      "summaryItems": {
        "one": "1 elemento por celda",
        "other": "{{count}} elementos por celda"
      },
      "summaryNoStimuli": "Añadir celdas",
      "summaryStimuli": {
        "one": "1 elemento",
        "other": "{{count}} elementos"
      },
      "title": "Título de la sección",
      "titlePlaceholder": "Introduce el título de la sección…",
      "useCase": {
        "ad_creative": {
          "addStimulus": "Añadir anuncio",
          "cellsPerRespondent": "Anuncios por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado evalúa 1 anuncio.",
            "other": "Cada encuestado evalúa {{count}} anuncios."
          },
          "requiresMediaHint": "Añade una imagen o vídeo para cada anuncio.",
          "stimuli": "Anuncios",
          "stimulusPlaceholder": "Anuncio {{index}}",
          "summaryCells": {
            "one": "1 anuncio por encuestado",
            "other": "{{count}} anuncios por encuestado"
          },
          "summaryNoStimuli": "Añadir anuncios",
          "summaryStimuli": {
            "one": "1 anuncio",
            "other": "{{count}} anuncios"
          }
        },
        "awareness": {
          "addStimulus": "Añadir marca",
          "stimuli": "Marcas",
          "stimulusPlaceholder": "Marca {{index}}",
          "summaryNoStimuli": "Añadir marcas",
          "summaryStimuli": {
            "one": "1 marca",
            "other": "{{count}} marcas"
          }
        },
        "claim_test": {
          "addStimulus": "Añadir afirmación",
          "cellsPerRespondent": "Afirmaciones por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado evalúa 1 afirmación.",
            "other": "Cada encuestado evalúa {{count}} afirmaciones."
          },
          "stimuli": "Afirmaciones",
          "stimulusPlaceholder": "Afirmación {{index}}",
          "summaryCells": {
            "one": "1 afirmación por encuestado",
            "other": "{{count}} afirmaciones por encuestado"
          },
          "summaryNoStimuli": "Añadir afirmaciones",
          "summaryStimuli": {
            "one": "1 afirmación",
            "other": "{{count}} afirmaciones"
          }
        },
        "max_diff": {
          "cellsPerRespondent": "Tareas por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado realiza 1 tarea MaxDiff.",
            "other": "Cada encuestado realiza {{count}} tareas MaxDiff."
          },
          "itemsPerCell": "Elementos por tarea",
          "itemsPerCellHint": {
            "one": "Se muestra 1 elemento por tarea MaxDiff.",
            "other": "Se muestran {{count}} elementos en cada tarea MaxDiff."
          },
          "summaryCells": {
            "one": "1 tarea por encuestado",
            "other": "{{count}} tareas por encuestado"
          },
          "summaryItems": {
            "one": "1 elemento por tarea",
            "other": "{{count}} elementos por tarea"
          }
        },
        "monadic": {
          "addStimulus": "Añadir concepto",
          "cellsPerRespondent": "Conceptos por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado evalúa 1 concepto.",
            "other": "Cada encuestado evalúa {{count}} conceptos."
          },
          "stimuli": "Conceptos",
          "stimulusPlaceholder": "Concepto {{index}}",
          "summaryCells": {
            "one": "1 concepto por encuestado",
            "other": "{{count}} conceptos por encuestado"
          },
          "summaryNoStimuli": "Añadir conceptos",
          "summaryStimuli": {
            "one": "1 concepto",
            "other": "{{count}} conceptos"
          }
        },
        "packaging": {
          "addStimulus": "Añadir packaging",
          "cellsPerRespondent": "Packagings por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado evalúa 1 packaging.",
            "other": "Cada encuestado evalúa {{count}} packagings."
          },
          "requiresMediaHint": "Añade una imagen para cada packaging.",
          "stimuli": "Packagings",
          "stimulusPlaceholder": "Packaging {{index}}",
          "summaryCells": {
            "one": "1 packaging por encuestado",
            "other": "{{count}} packagings por encuestado"
          },
          "summaryNoStimuli": "Añadir packagings",
          "summaryStimuli": {
            "one": "1 packaging",
            "other": "{{count}} packagings"
          }
        },
        "preference_test": {
          "addStimulus": "Añadir variante",
          "stimuli": "Variantes",
          "stimulusPlaceholder": "Variante {{index}}",
          "summaryNoStimuli": "Añadir variantes",
          "summaryStimuli": {
            "one": "1 variante",
            "other": "{{count}} variantes"
          }
        },
        "price_elasticity": {
          "cellsPerRespondent": "Productos por encuestado",
          "cellsPerRespondentHint": {
            "one": "Cada encuestado fija el precio de 1 producto.",
            "other": "Cada encuestado fija el precio de {{count}} productos."
          },
          "summaryCells": {
            "one": "1 producto por encuestado",
            "other": "{{count}} productos por encuestado"
          }
        }
      }
    },
    "shareDescription": "Este es un enlace público a tu estudio. Cualquier persona con este enlace puede verlo en modo de solo lectura.",
    "shareResults": "Compartir resultados",
    "shareTitle": "Compartir resultados",
    "sharing": "Compartiendo...",
    "startChattingWithAI": "Comienza a chatear con IA para analizar los resultados de tu estudio",
    "studyChat": "Chat del estudio",
    "studyDescription": "Descripción",
    "studyDescriptionPlaceholder": "Introduce una descripción detallada de tu estudio...",
    "studyName": "Nombre",
    "studyNamePlaceholder": "Introduce el nombre del estudio...",
    "studyType": "Tipo de estudio",
    "summariesProgress": {
      "one": "{{completed}}/{{count}} resumen",
      "other": "{{completed}}/{{count}} resúmenes"
    },
    "summaryLoadingAnalyzing": "Analizando patrones entre segmentos de encuestados…",
    "summaryLoadingCompiling": "Compilando hallazgos por demografía y segmento…",
    "summaryLoadingDrafting": "Redactando resumen ejecutivo y recomendaciones…",
    "summaryLoadingIdentifying": "Identificando temas clave y señales de sentimiento…",
    "timeElapsed": "Tiempo transcurrido: {{time}}",
    "timeRemaining": "Tiempo estimado restante: {{time}}",
    "triggeringSimulation": "Iniciando...",
    "typeYourMessage": "Escribe tu mensaje...",
    "useCasePicker": {
      "custom": "Sección personalizada",
      "customDescription": "Empieza con una sección en blanco y añade tus propias preguntas.",
      "title": "Elige un caso de uso para empezar"
    },
    "viewDetailed": "Ver detalle",
    "viewReport": "Ver informe",
    "waitingForProgress": "Esperando progreso...",
    "workingOnItMessage": "Toma un café mientras ejecutamos tu estudio...",
    "workingOnItMessageAlmostReady": "Aguanta, tu información está casi lista..."
  },
  "useCasePage": {
    "adCreative": {
      "ctaSubtitle": "Obtén reacciones a tus anuncios en menos de 10 minutos.",
      "ctaTitle": "Lanza una prueba de creatividad publicitaria",
      "methodology": {
        "description": "Cada respondiente ve todos tus anuncios, uno a la vez, y responde las mismas cinco preguntas sobre cada uno. Como cada anuncio se evalúa solo, los puntajes reflejan reacciones autónomas, como si el anuncio se viera en condiciones reales.",
        "metrics": {
          "likingIndex": {
            "description": "Un puntaje combinado de agrado, encaje con la marca e interés de compra, para tener un solo número comparable por anuncio.",
            "title": "Índice de agrado"
          },
          "takeaway": {
            "description": "Lo que los consumidores realmente creen que dice el anuncio, con sus propias palabras.",
            "title": "Temas retenidos"
          }
        },
        "name": "Monádico secuencial"
      },
      "provide": {
        "description": "1 a 5 piezas creativas: imágenes, animáticos o clips cortos. Un título de trabajo corto para cada una hace el reporte más legible.",
        "examples": {
          "functional": {
            "description": "Spot de producto de 15 segundos enfocado en el dorado y un texto preciso del porcentaje de cacao.",
            "name": "Acercamiento funcional"
          },
          "heritage": {
            "description": "Película cinematográfica de 60 segundos que sigue un grano de cacao desde una finca ghanesa hasta la barra terminada.",
            "name": "Spot Héroe de herencia"
          },
          "lifestyle": {
            "description": "Escena urbana de 30 segundos con amigos compartiendo la barra en una cena en una azotea.",
            "name": "Momento de vida"
          }
        },
        "title": "Tus anuncios"
      },
      "sampleReport": {
        "ads": {
          "functional": {
            "name": "Acercamiento funcional"
          },
          "heritage": {
            "name": "Héroe de herencia"
          },
          "lifestyle": {
            "name": "Momento de vida"
          }
        },
        "metrics": {
          "brandFit": "Encaje con la marca",
          "interest": "Interés",
          "liking": "Agrado",
          "subtitle": "Cuota top 2 cajas para cada anuncio en cada escala, junto con el tema retenido.",
          "title": "Cómo se desempeñó cada anuncio, por métrica"
        },
        "ranking": {
          "subtitle": "Puntaje combinado de las tres preguntas de calificación, en una escala de 0 a 100.",
          "title": "Índice de agrado por anuncio"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, 3 anuncios probados.",
        "summary": {
          "body": "Héroe de herencia obtiene el mejor puntaje combinado gracias a una narrativa clara y un fuerte encaje con la marca. Momento de vida resulta divertido pero genérico: alto agrado, bajo encaje con la marca. Acercamiento funcional es el más fácil de entender pero el más difícil de hacer sentir algo: la comprensión es casi perfecta, la intención es la más baja de los tres.",
          "headline": "Héroe de herencia lidera en agrado e intención, mientras que Acercamiento funcional gana en claridad pero pierde en emoción."
        },
        "winner": {
          "badge": "Creatividad líder",
          "compositeLabel": "Índice de agrado",
          "subtitle": "Mejor puntaje combinado en agrado, encaje con la marca e interés."
        }
      }
    },
    "awareness": {
      "ctaSubtitle": "Obtén un embudo de notoriedad limpio en menos de 10 minutos.",
      "ctaTitle": "Lanza un estudio de notoriedad",
      "methodology": {
        "description": "La notoriedad se mide en dos etapas, en un orden fijo para evitar el priming. Primero, los encuestados escriben las marcas que les vienen a la mente para la categoría. Después se les muestra tu lista completa de marcas y marcan todas las que conocen. Las menciones espontáneas se contrastan después con la misma lista para calcular el recuerdo espontáneo.",
        "metrics": {
          "aided": {
            "description": "Porcentaje de encuestados que reconocen una marca al verla en tu lista de candidatas. El techo: la familiaridad pasiva.",
            "title": "Notoriedad sugerida"
          },
          "unaided": {
            "description": "Porcentaje de encuestados que mencionan una marca espontáneamente, sin ver ninguna lista. El listón más alto: el recuerdo activo.",
            "title": "Notoriedad espontánea"
          }
        },
        "name": "Embudo de notoriedad en dos etapas"
      },
      "provide": {
        "description": "Las marcas que quieres medir. De 3 a 15 marcas.",
        "title": "Lista de marcas"
      },
      "sampleReport": {
        "brands": {
          "cadbury": "Cadbury",
          "ferrero": "Ferrero Rocher",
          "ghirardelli": "Ghirardelli",
          "godiva": "Godiva",
          "hersheys": "Hershey's",
          "lindt": "Lindt",
          "milka": "Milka",
          "toblerone": "Toblerone"
        },
        "chart": {
          "aidedLabel": "Sugerida",
          "subtitle": "Menciones espontáneas frente a reconocimiento en lista, por marca.",
          "title": "Embudo de notoriedad",
          "unaidedLabel": "Espontánea"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, categoría chocolate premium.",
        "summary": {
          "body": "El embudo esconde varias inversiones. Cadbury (38 % espontánea) supera a Hershey's (33 %) pese a tener una cobertura sugerida menor, señal de que la posición top-of-mind no sigue el ranking en sugerida. Toblerone (82 % sugerida / 16 % espontánea) y Godiva (71 % / 8 %) registran las mayores brechas reconocimiento-sin-recuerdo del panel: los consumidores conocen los nombres pero no aparecen cuando se piensa en la categoría. Milka mantiene la mejor ratio espontánea-sobre-sugerida del panel, lo que sugiere una base de mindshare reducida pero leal.",
          "headline": "Lindt es la marca top-of-mind de la categoría con un 54 % espontánea y un 91 % sugerida, manteniendo 16 puntos de ventaja sobre Cadbury, la siguiente marca más recordada de forma espontánea."
        },
        "topOfMind": {
          "badge": "Top-of-mind",
          "subtitle": "Marca más mencionada cuando los encuestados escribían sin ver ninguna lista.",
          "unaidedLabel": "Recuerdo espontáneo"
        }
      }
    },
    "claimTest": {
      "ctaSubtitle": "Elige el claim correcto en menos de 10 minutos.",
      "ctaTitle": "Lanza una prueba de claim",
      "methodology": {
        "description": "Cada respondiente lee cada claim, uno a la vez, y responde las mismas preguntas sobre cada uno. Como cada claim se juzga por sí solo, los puntajes reflejan cómo cae realmente cada uno, sin la distorsión de una comparación directa.",
        "metrics": {
          "meaning": {
            "description": "Lo que los consumidores creen que el claim realmente significa, con sus propias palabras.",
            "title": "Comprobación de significado"
          },
          "persuasion": {
            "description": "Un puntaje combinado de credibilidad, distinción y motivación, para tener un solo número comparable por claim.",
            "title": "Puntaje de persuasión"
          }
        },
        "name": "Monádico secuencial"
      },
      "provide": {
        "description": "1 a 5 claims, eslóganes o promesas de producto. Mantenlos cortos: una frase funciona mejor.",
        "examples": {
          "craft": "70 horas de conchado lento para un acabado más sedoso y profundo.",
          "origin": "Cacao ghanés de origen único, de origen ético y prensado en frío.",
          "purpose": "El 10 % de cada barra financia la reforestación en África Occidental."
        },
        "title": "Tus claims"
      },
      "sampleReport": {
        "claims": {
          "craft": {
            "name": "70 horas de conchado lento"
          },
          "origin": {
            "name": "Cacao ghanés de origen único"
          },
          "purpose": {
            "name": "10 % financia la reforestación"
          }
        },
        "metrics": {
          "believability": "Creíble",
          "motivation": "Motivador",
          "subtitle": "Cuota top 2 cajas para cada claim en cada escala, junto con cómo lo leen los respondientes.",
          "title": "Cómo se desempeñó cada claim, por métrica",
          "uniqueness": "Diferente"
        },
        "ranking": {
          "subtitle": "Puntaje combinado de las tres preguntas de calificación, en una escala de 0 a 100.",
          "title": "Puntaje de persuasión por claim"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, 3 claims probados.",
        "summary": {
          "body": "Cacao ghanés de origen único obtiene el mejor puntaje combinado gracias a un significado claro y una fuerte credibilidad. El claim del conchado es el más distintivo pero el más difícil de accionar: la mitad de los respondientes no tiene claro por qué importa. El claim de propósito conmueve pero suena familiar, ya que muchos esperan un origen ético de las marcas premium.",
          "headline": "El claim de origen gana en persuasión y motivación; el claim de propósito resuena pero se siente menos único."
        },
        "winner": {
          "badge": "Claim líder",
          "compositeLabel": "Puntaje de persuasión",
          "subtitle": "Mejor puntaje combinado en credibilidad, distinción y motivación."
        }
      }
    },
    "example": "Ejemplo",
    "getStarted": "Comenzar",
    "maxDiff": {
      "ctaSubtitle": "La configuración toma menos de 2 minutos: pega tu lista de elementos y nosotros nos encargamos del resto.",
      "ctaTitle": "Lanza un estudio MaxDiff",
      "methodology": {
        "description": "En lugar de pedir a los encuestados que valoren los elementos individualmente, donde la mayoría termina con buena puntuación, MaxDiff muestra pequeños subconjuntos y pide elegir el mejor y el peor en cada uno. Repetido a lo largo de muchas rondas, esto produce un orden preciso con diferencias claras entre los elementos.",
        "metrics": {
          "discrimination": {
            "description": "Distinciones más nítidas que las escalas de valoración, incluso cuando todos los elementos resultan atractivos individualmente",
            "title": "Discriminación"
          },
          "preferenceScore": {
            "description": "Clasificación ponderada por utilidad que cuantifica cuánto se prefiere cada elemento",
            "title": "Puntuación de preferencia"
          }
        },
        "name": "Escalado mejor-peor"
      },
      "provide": {
        "description": "4 a 20 funciones, afirmaciones, mensajes o atributos distintos que quieras priorizar. Las formulaciones cortas y claras funcionan mejor.",
        "title": "Lista de elementos"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Cada barra muestra cuánto se desvía un elemento de la preferencia media. Las barras a la derecha indican una preferencia superior a la media; las de la izquierda, inferior.",
          "title": "Puntuaciones de preferencia"
        },
        "items": {
          "artisans": "Hecho por pequeños artesanos",
          "fairTrade": "Certificado de comercio justo",
          "lowSugar": "Bajo contenido de azúcar",
          "premium": "Experiencia de chocolate negro premium",
          "richFlavor": "Sabor intenso y rico",
          "singleOrigin": "Cacao de origen único",
          "smoothTexture": "Textura suave",
          "sustainable": "Empaque sostenible",
          "unique": "Combinaciones de sabores únicas",
          "variety": "Amplia variedad de sabores"
        },
        "subjectLine": "Atributos de una tableta de chocolate premium · n = {{count}}",
        "summary": {
          "body": "Los impulsores sensoriales dominan: sabor intenso, menor contenido de azúcar y textura suave capturan en conjunto el 46 % de la preferencia total. Los argumentos con propósito (abastecimiento sostenible, comercio justo y producción artesanal en pequeños lotes) se agrupan en torno o por debajo de la media del 10 %, lo que sugiere que tranquilizan en lugar de impulsar la elección.",
          "headline": "El sabor rico e intenso lidera el panel con un 18,5 %, casi cinco veces más que el argumento artesanal en pequeños lotes, con un 3,9 %."
        }
      }
    },
    "metricLabel": "Métrica {{letter}}",
    "monadic": {
      "ctaSubtitle": "Obtén puntuaciones limpias y comparables en menos de 10 minutos.",
      "ctaTitle": "Lanza una prueba de concepto",
      "methodology": {
        "description": "En la prueba monádica, a cada encuestado se le asigna aleatoriamente un concepto (o una breve secuencia de conceptos) extraído de tu pool, y lo califica de forma aislada en una batería de cinco preguntas. Como ningún encuestado compara conceptos uno al lado del otro, las puntuaciones reflejan el atractivo individual de cada concepto, tal como se encontraría en el lineal o en pantalla.",
        "metrics": {
          "compositeScore": {
            "description": "Promedio del top-2-box en las cinco métricas. La cifra principal usada para clasificar los conceptos.",
            "title": "Puntuación compuesta"
          },
          "topTwoBox": {
            "description": "Porcentaje de encuestados que valoraron una métrica con 4 o 5 en la escala de cinco puntos. El KPI estándar de la prueba de concepto.",
            "title": "Top-2-box"
          }
        },
        "name": "Prueba de concepto monádica"
      },
      "provide": {
        "description": "Tu pool de conceptos candidatos (de 1 a 20), cada uno con un nombre y una descripción breve (imagen opcional).",
        "title": "Pool de conceptos"
      },
      "sampleReport": {
        "concepts": {
          "functional": {
            "description": "Una barra enriquecida con proteína y baja en azúcar, orientada a estilos de vida activos y al clean-label.",
            "name": "Cocoa+ Functional"
          },
          "heritage": {
            "description": "Una tableta premium de origen único, con trazabilidad del grano y narrativa de sostenibilidad.",
            "name": "Heritage Cocoa Co."
          },
          "velvet": {
            "description": "Un chocolate con leche cremoso para el día a día, pensado para la compra semanal en familia.",
            "name": "Velvet Daily"
          }
        },
        "heatmap": {
          "subtitle": "Puntuaciones top-2-box por concepto (las celdas se sombrean según la puntuación; cuanto más oscuras, más fuertes).",
          "title": "Detalle por métrica"
        },
        "metrics": {
          "purchaseIntent": "Intención de compra",
          "recommend": "Probabilidad de recomendar",
          "relevance": "Relevancia para mí",
          "uniqueness": "Carácter único",
          "valueForMoney": "Relación calidad-precio"
        },
        "ranking": {
          "subtitle": "Puntuación compuesta top-2-box, promediada en las cinco métricas.",
          "title": "Clasificación de conceptos"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores ({{perCell}} por concepto), 3 conceptos candidatos.",
        "summary": {
          "body": "Heritage encarna la narrativa premium: el carácter único (78 %) y la probabilidad de recomendar (71 %) sostienen su victoria, pero Velvet Daily es el campeón en relación calidad-precio (72 %) y el concepto más relevante (64 %), lo que lo convierte en su contrapeso natural para el día a día. El ángulo restringido de salud de Cocoa+ Functional lastra la intención de compra (45 %) pese a una distintividad aceptable, y difícilmente podría sostener un lanzamiento por sí solo.",
          "headline": "Heritage Cocoa Co. gana el compuesto con 62 %, superando a Velvet Daily por 3,4 puntos y a Cocoa+ Functional por 13 puntos."
        },
        "winner": {
          "badge": "Concepto ganador",
          "compositeLabel": "Compuesto",
          "subtitle": "Mayor puntuación compuesta top-2-box en las cinco métricas."
        }
      }
    },
    "notFound": "Caso de uso no encontrado",
    "nps": {
      "ctaSubtitle": "Dos preguntas, un solo número, listo en menos de un minuto.",
      "ctaTitle": "Lanza un estudio NPS",
      "methodology": {
        "description": "El Net Promoter Score es el indicador de lealtad estándar del sector. Los encuestados puntúan la probabilidad de recomendar en una escala de 0 a 10 y luego justifican brevemente su nota. Las puntuaciones se agrupan en Detractores (0–6), Pasivos (7–8) y Promotores (9–10), y NPS = %Promotores − %Detractores. La justificación abierta convierte un número plano en temas accionables.",
        "metrics": {
          "breakdown": {
            "description": "Proporción de Detractores (0–6), Pasivos (7–8) y Promotores (9–10): el perfil de lealtad detrás del score.",
            "title": "Perfil de lealtad"
          },
          "score": {
            "description": "%Promotores menos %Detractores, en una escala de −100 a +100. El número único para hacer seguimiento de la lealtad en el tiempo.",
            "title": "Score NPS"
          }
        },
        "name": "Net Promoter Score"
      },
      "provide": {
        "description": "Una breve descripción del producto, servicio o experiencia que se evalúa.",
        "example": "Tableta de chocolate negro premium (70 % cacao, 100 g): producto insignia, seis meses después de un cambio reciente de receta.",
        "title": "Lo que estás midiendo"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Detractores 0–6 · Pasivos 7–8 · Promotores 9–10. Las barras muestran la proporción de encuestados en cada nota.",
          "title": "Distribución de puntuaciones"
        },
        "score": {
          "badge": "Score principal",
          "classification": "Bueno",
          "subtitle": "Por encima de cero y en territorio sólido: los promotores superan cómodamente a los detractores, con margen para crecer."
        },
        "segments": {
          "count": "{{count}} encuestados",
          "detractors": {
            "band": "Notas 0–6"
          },
          "passives": {
            "band": "Notas 7–8"
          },
          "promoters": {
            "band": "Notas 9–10"
          }
        },
        "subjectLine": "Tableta de chocolate negro premium · n = {{count}} consumidores",
        "summary": {
          "body": "El mayor grupo se sitúa en la zona pasiva: el 33 % de los encuestados dan un 7 o un 8: están satisfechos pero no entusiasmados. Convertir solo a la mitad de ellos en promotores haría subir el NPS por encima de +50, en territorio del cuartil superior. La base de detractores es estrecha (18 %) y se concentra en notas de 6 en lugar del fondo 0–3, lo que sugiere fricciones corregibles en lugar de insatisfacción arraigada.",
          "headline": "Un NPS de +31 sitúa la tableta en territorio sólido de lealtad, con los promotores (49 %) claramente por encima de los detractores (18 %)."
        }
      }
    },
    "packaging": {
      "ctaSubtitle": "Elige el empaque que gana en el anaquel en menos de 10 minutos.",
      "ctaTitle": "Lanza una prueba de empaque",
      "methodology": {
        "description": "Cada respondiente ve todos tus diseños de empaque, uno a la vez, y responde las mismas preguntas sobre cada uno. Como cada empaque se juzga por sí solo, los puntajes reflejan cómo cae realmente cada diseño, sin el sesgo de una comparación directa.",
        "metrics": {
          "clarity": {
            "description": "Si los consumidores identifican correctamente qué producto es, con solo mirar el empaque.",
            "title": "Comprobación de claridad"
          },
          "shelfAppeal": {
            "description": "Un puntaje combinado de atractivo e intención de tomarlo en el anaquel, para tener un solo número comparable por empaque.",
            "title": "Atractivo en anaquel"
          }
        },
        "name": "Monádico secuencial"
      },
      "provide": {
        "description": "1 a 5 diseños de empaque como imágenes. Un título de trabajo corto para cada uno hace el reporte más legible.",
        "examples": {
          "heritage": {
            "description": "Motivo de mazorca de cacao dibujado a mano sobre una base estilo kraft, escudo de la marca centrado arriba.",
            "name": "Herencia ilustrada"
          },
          "minimalist": {
            "description": "Tipografía serif limpia sobre una funda mate satinada con un porcentaje estampado en lámina dorada.",
            "name": "Minimalista dorada"
          },
          "vibrant": {
            "description": "Bloque de color vibrante, logo sin serifas, nombre del sabor en tipografía sobredimensionada.",
            "name": "Moderno vibrante"
          }
        },
        "title": "Tus empaques"
      },
      "sampleReport": {
        "metrics": {
          "appeal": "Atractivo",
          "brandFit": "Encaje con la marca",
          "shelfIntent": "Intención de tomar",
          "subtitle": "Cuota top 2 cajas para cada empaque en cada escala, junto con cómo lo leen los respondientes.",
          "title": "Cómo se desempeñó cada empaque, por métrica"
        },
        "packs": {
          "heritage": {
            "name": "Herencia ilustrada"
          },
          "minimalist": {
            "name": "Minimalista dorada"
          },
          "vibrant": {
            "name": "Moderno vibrante"
          }
        },
        "ranking": {
          "subtitle": "Puntaje combinado de las tres preguntas de calificación, en una escala de 0 a 100.",
          "title": "Atractivo en anaquel por empaque"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, 3 empaques probados.",
        "summary": {
          "body": "Minimalista dorada obtiene el mejor puntaje combinado gracias a una fuerte intención de tomarlo y un buen encaje con la marca. Herencia ilustrada se lee como la más premium y distintiva, pero sus ilustraciones confunden a un tercio de los respondientes sobre qué producto es realmente. Moderno vibrante se reconoce más rápido pero se siente como el menos premium de los tres.",
          "headline": "Minimalista dorada gana en atractivo e intención de tomar; Herencia ilustrada comunica la señal premium más fuerte."
        },
        "winner": {
          "badge": "Empaque líder",
          "compositeLabel": "Atractivo en anaquel",
          "subtitle": "Mejor puntaje combinado en atractivo e intención de tomar."
        }
      }
    },
    "pastResults": "Resultados anteriores",
    "preferenceTest": {
      "ctaSubtitle": "Elige a un ganador en menos de 10 minutos.",
      "ctaTitle": "Lanza una prueba de preferencia",
      "methodology": {
        "description": "Cada respondiente ve todas tus opciones en la misma pantalla y elige la que prefiere, luego explica por qué con sus propias palabras. Al ser una elección directa, obtienes un ganador claro y las razones detrás del veredicto.",
        "metrics": {
          "reasons": {
            "description": "Principales temas de las explicaciones abiertas, agrupados por la opción que se llevó el voto.",
            "title": "Razones para ganar"
          },
          "winRate": {
            "description": "Porcentaje de respondientes que eligieron cada opción como su favorita.",
            "title": "Cuota de victoria"
          }
        },
        "name": "Comparación de elección forzada"
      },
      "provide": {
        "description": "2 a 5 opciones para comparar. Pueden ser imágenes (anuncios, empaques) o textos cortos (claims, eslóganes).",
        "examples": {
          "optionA": {
            "description": "Película cinematográfica que sigue un solo grano de cacao desde la finca hasta la barra.",
            "name": "Opción A: Héroe de herencia"
          },
          "optionB": {
            "description": "Amigos compartiendo la barra en una cena en una azotea.",
            "name": "Opción B: Momento de vida"
          },
          "optionC": {
            "description": "Plano cerrado del producto enfocado en el dorado y el porcentaje de cacao.",
            "name": "Opción C: Acercamiento funcional"
          }
        },
        "title": "Tus opciones"
      },
      "sampleReport": {
        "options": {
          "optionA": {
            "name": "Héroe de herencia",
            "themes": "Narrativa · oficio · autenticidad"
          },
          "optionB": {
            "name": "Momento de vida",
            "themes": "Divertido · compartible · se siente genérico"
          },
          "optionC": {
            "name": "Acercamiento funcional",
            "themes": "Producto claro · olvidable"
          }
        },
        "reasons": {
          "subtitle": "Principales temas de las explicaciones abiertas, ordenados por frecuencia.",
          "title": "Por qué la eligieron"
        },
        "share": {
          "subtitle": "Cada barra muestra cuántos de los {{count}} respondientes eligieron esa opción como favorita.",
          "title": "Reparto de votos"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, 3 anuncios comparados.",
        "summary": {
          "body": "Héroe de herencia gana en el plano emocional: los respondientes mencionan repetidamente el viaje de la finca a la barra y la sensación de quedar atrapados. Momento de vida resulta divertido y compartible pero se siente genérico para dos tercios de los respondientes. Acercamiento funcional es el mensaje más claro pero el menos memorable: nadie lo menciona sin que se le pregunte.",
          "headline": "Héroe de herencia se lleva el 52 % de los votos, el doble que el segundo. La narrativa es lo que inclina la balanza."
        },
        "votesLabel": "{{count}} votos",
        "winner": {
          "badge": "Opción líder",
          "compositeLabel": "Cuota de victoria"
        }
      }
    },
    "priceElasticity": {
      "ctaSubtitle": "La configuración toma menos de 2 minutos con nuestra plantilla automatizada.",
      "ctaTitle": "Lanza un estudio de precio",
      "methodology": {
        "description": "En lugar de preguntar «¿cuánto pagaría?», este enfoque utiliza cuatro preguntas específicas para identificar las barreras psicológicas de precio. Al mapear estas percepciones, visualizamos el equilibrio entre el precio y la calidad percibida.",
        "metrics": {
          "opp": {
            "description": "El punto ideal donde la resistencia del consumidor es mínima",
            "title": "Precio óptimo (OPP)"
          },
          "range": {
            "description": "Límites entre los umbrales «Barato» y «Caro»",
            "title": "Rango de precios aceptables"
          }
        },
        "name": "La metodología Van Westendorp"
      },
      "provide": {
        "description": "Una descripción clara de tu producto o servicio, o una foto, para que los encuestados tengan suficiente contexto para fijar un precio.",
        "example": "Tableta de chocolate negro orgánico premium (70 % de cacao, 100 g), de origen único de Ecuador, de comercio ético y empaquetada en papel reciclable.",
        "title": "Descripción o foto"
      },
      "questions": {
        "bargain": {
          "title": "Ganga"
        },
        "expensive": {
          "title": "Caro"
        },
        "tooCheap": {
          "title": "Demasiado barato"
        },
        "tooExpensive": {
          "title": "Demasiado caro"
        }
      }
    },
    "sampleReport": {
      "badge": "Informe de ejemplo",
      "disclaimer": "Todos los datos mostrados son ilustrativos.",
      "histogram": {
        "subtitle": "Distribución de los precios indicados por los encuestados para cada pregunta de umbral.",
        "title": "Distribución de precios"
      },
      "keyInsights": "Claves principales",
      "subjectLine": "Tableta de chocolate negro orgánico premium · n = {{count}}",
      "summary": {
        "body": "En el precio óptimo ({{opp}}), una proporción igual de consumidores encuentra el producto demasiado barato o demasiado caro, minimizando la resistencia en ambos lados. Fijar el precio por debajo de {{pmc}} corre el riesgo de transmitir baja calidad, mientras que por encima de {{pme}} expulsa a la mayoría de los consumidores del conjunto de consideración. El precio de indiferencia ({{ipp}}) marca el punto donde tantos consumidores ven el producto como una ganga como caro, un anclaje sólido para un posicionamiento cotidiano.",
        "headline": "El precio óptimo se sitúa en {{opp}}, con un rango aceptable entre {{pmc}} y {{pme}}."
      },
      "vw": {
        "ippLabel": "Indiferencia · {{price}}",
        "ippShort": "IPP",
        "oppLabel": "Óptimo · {{price}}",
        "oppShort": "OPP",
        "pmcLabel": "Suelo · {{price}}",
        "pmcShort": "PMC",
        "pmeLabel": "Techo · {{price}}",
        "pmeShort": "PME",
        "subtitle": "Proporción acumulada de encuestados en cada nivel de precio. Las intersecciones revelan el precio óptimo y el rango aceptable.",
        "title": "Curvas de sensibilidad al precio de Van Westendorp",
        "xLabel": "Precio"
      }
    },
    "turf": {
      "ctaSubtitle": "Obtén una respuesta en menos de 10 minutos.",
      "ctaTitle": "Lanza un estudio TURF",
      "methodology": {
        "description": "TURF (alcance no duplicado y frecuencia total) prueba todas las combinaciones posibles de tu lista candidata para encontrar el surtido que alcanza al mayor número de encuestados únicos manteniendo bajo el solapamiento.",
        "metrics": {
          "frequency": {
            "description": "Número promedio de elementos que cada encuestado consideraría dentro de un portafolio dado.",
            "title": "Frecuencia"
          },
          "reach": {
            "description": "Porcentaje de encuestados que considerarían al menos un elemento del portafolio.",
            "title": "Alcance no duplicado"
          }
        },
        "name": "Alcance no duplicado y frecuencia total"
      },
      "provide": {
        "description": "De 5 a 20 productos, sabores, características o mensajes distintos que podrías ofrecer. Las formulaciones cortas y claras funcionan mejor.",
        "title": "Lista de elementos"
      },
      "sampleReport": {
        "chart": {
          "elbowLabel": "Tamaño óptimo del portafolio",
          "reachLabel": "Alcance no duplicado",
          "subtitle": "Cada punto muestra la parte de la audiencia cubierta por el mejor portafolio de ese tamaño. El punto marcado es donde añadir un elemento más deja de aportar mejora.",
          "title": "Alcance por tamaño de portafolio",
          "xLabel": "Tamaño del portafolio",
          "yLabel": "Alcance"
        },
        "items": {
          "almond": "Chocolate con almendras",
          "coconut": "Chocolate con coco",
          "dark": "Chocolate negro (70 % cacao)",
          "hazelnut": "Chocolate con avellanas",
          "milk": "Chocolate con leche",
          "mint": "Chocolate de menta",
          "orange": "Chocolate con naranja",
          "raspberry": "Chocolate con frambuesa",
          "saltedCaramel": "Chocolate con caramelo salado",
          "white": "Chocolate blanco"
        },
        "portfolio": {
          "reachLabel": "Alcance no duplicado",
          "subtitle": "Surtido óptimo de {{size}} elementos",
          "title": "Portafolio recomendado"
        },
        "rawCounts": {
          "subtitle": "Cuántos encuestados considerarían cada sabor por separado. La optimización superior se apoya en estas señales para encontrar el surtido más pequeño que cubra al mayor número de compradores únicos.",
          "title": "Selección por sabor"
        },
        "subjectLine": "Estudio sintético, n = {{count}} consumidores, 10 sabores candidatos.",
        "summary": {
          "body": "El chocolate con leche es el atractivo individual más fuerte con un 37 %, pero el surtido óptimo solo funciona porque la menta llega a compradores que los sabores cacaoteros no alcanzan. Los cuatro rezagados (blanco, naranja, frambuesa y coco) rinden poco por sí solos y aportan poco una vez que los cinco favoritos están en el surtido.",
          "headline": "Leche, negro, caramelo salado, avellana y menta alcanzan juntos al 84 % de los compradores; añadir un sexto sabor solo aporta 1,5 puntos más."
        }
      }
    },
    "viewSampleReport": "Ver informe de ejemplo",
    "whatYoullProvide": "Lo que tendrás que proporcionar"
  }
}
